import { memo, useCallback, useState } from 'react';
import PlayerTimelineButton from '../PlayerTimelineButton';
import { AddMenuPopover } from './';

const AddMenuButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      <PlayerTimelineButton
        tooltipTitle="Add at current time..."
        buttonId="timeline-add-menu-button"
        onClick={handleClick}
        iconName="IconPlus"
        isDisabled={false}
      />
      {isOpen && <AddMenuPopover isOpen={isOpen} onClose={handleClose} />}
    </>
  );
};

export default memo(AddMenuButton);
